import { render, staticRenderFns } from "./DuplicationDetails.vue?vue&type=template&id=6c354b94&scoped=true"
import script from "./DuplicationDetails.vue?vue&type=script&lang=ts"
export * from "./DuplicationDetails.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c354b94",
  null
  
)

export default component.exports